import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

// IMPORTANT: Charger l'intercepteur CORS en premier
import './corsInterceptor';

import reducers from './redux/reducers';
import './assets/css/demo.css';
import './assets/css/style.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Initialiser la configuration Firebase normale d'abord
import './config/firebase';

// Les intercepteurs hors-ligne seront chargés après le rendu initial
// setTimeout(() => {
//     import('./helpers/apiInterceptor').catch(err => {
//     });
// }, 100);

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/sass/light-bootstrap-dashboard-pro-react.scss?v=1.2.0";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";
import "./assets/css/style.css";

const store = createStore(
    reducers,
    applyMiddleware(thunk)
);


ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);

serviceWorker.register();
